import { Button } from '@ewf/components/Button';
import { CloseButton } from '@ewf/components/ModalUI/CloseButton';
import { ModalContainer } from '@ewf/components/ModalUI/ModalContainer';
import { WalletButton } from '@ewf/components/ModalUI/WalletSelector/WalletButton';
import { SunkenBox } from '@ewf/components/SunkenBox';
import { useState } from 'react';
import ethLogo from '@ewf/assets/logos/eth.svg';
import ewcLogo from '@ewf/assets/logos/ew.svg';
import { LIFTING_CHAINS, MARKETPLACE_CHAINS } from '@shared/types/enums';

export const SelectNetwork = ({ onNext, onClose, defaultNetwork }: Props) => {
  const [selectedNetwork, setSelectedNetwork] = useState<LIFTING_CHAINS>(defaultNetwork);

  return (
    <ModalContainer>
      <section className="mb-8 flex justify-end">
        <CloseButton onClick={onClose} />
      </section>
      <section className="mb-8">
        <div className="rounded-lg p-6 bg-popup-gradient">
          <SunkenBox className="mb-8 text-center">
            <p className="mb-1 text-lg font-bold text-white">Select your preferred network</p>
          </SunkenBox>
          <div className="grid grid-cols-2 gap-6">
            <WalletButton
              isSelected={selectedNetwork === MARKETPLACE_CHAINS.ETH}
              onSelect={() => setSelectedNetwork(MARKETPLACE_CHAINS.ETH)}
            >
              <img src={ethLogo} width={56} height={56} alt="Ethereum" />
              <p>Ethereum</p>
            </WalletButton>
            <WalletButton
              isSelected={selectedNetwork === MARKETPLACE_CHAINS.EWC}
              onSelect={() => setSelectedNetwork(MARKETPLACE_CHAINS.EWC)}
            >
              <img src={ewcLogo} width={56} height={56} alt="Energy Web Chain" />
              <p>Energy Web Chain</p>
            </WalletButton>
          </div>
        </div>
      </section>
      <section className="flex justify-center">
        <Button onClick={() => onNext(selectedNetwork)}>Continue</Button>
      </section>
    </ModalContainer>
  );
};

interface Props {
  defaultNetwork: LIFTING_CHAINS;
  onNext: (network: LIFTING_CHAINS) => void;
  onClose: () => void;
}
